<script>
  import { page } from 'inertiax-svelte'
  import MenuDrawer, { toggle } from '~/lib/ui/MenuDrawer.svelte'
  import { Modal, ViewStack } from 'inertiax-viewstack'
  import { Frame } from 'inertiax-svelte'
  import { currentUser } from '~/lib/stores'
  import './default.css'
  
  const {
    children
  } = $props()

  // What the page said about itself (ApplicationController#page_meta). It is read
  // off the Inertia page rather than passed down, because the layout is what
  // owns <head> - and it outlives the page it is describing.
  const meta = $derived(page.props.meta ?? {})
  const title = $derived(meta.title ?? "Shitcoin Swap - The front page of crypto")

  const taglines = [
    "Admin confirms that everything is 100% legit",
    "Admin confirms that Shitcoin Swap is totally not a scam",
    "Admin confirms that Shitcoin Swap is not regulated by FINMA",
    "Admin confirms that Shitcoin Swap website is not AI generated",
    "Admin confirms that Shitcoin Swap is not licensed by anyone to do anything",
    "Suck it, Garry",
    "🌈🦄💩",
    "We're delisting Enron",
    "We're delisting OneCoin",
    "We're delisting BitConnect",
    "We're delisting SafeMoon",
    "We're delisting CryptoZoo",
    "DJ Diesel distances himself from FTX",
    "It's all worthless 😱",
    "Gooble gobble one of us"
  ]
</script>

<svelte:head>
  <title>{title}</title>
  <meta property="og:type" content="website" />
  <meta property="og:title" content={title} />
  {#if meta.description}
    <meta name="description" content={meta.description} />
    <meta property="og:description" content={meta.description} />
  {/if}
  {#if meta.image}
    <!-- The card is drawn on the server (AssetSocialPreview) and attached to the
         asset, so that a crawler - which does not run this app - finds an image
         already waiting at the url it is given. -->
    <meta property="og:image" content={meta.image.url} />
    <meta property="og:image:width" content={meta.image.width} />
    <meta property="og:image:height" content={meta.image.height} />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:image" content={meta.image.url} />
  {/if}
</svelte:head>

<div class="layout">

<main>
  {@render children?.()}
</main>

  
<header>
  <section>
    <div class="flex items-center">
      <a href="/" class="brand grow">
        <img src="~/assets/logo.svg" class="h-8 inline-block" alt="Shitcoin Swap Logo"/>
        <img src="~/assets/shitcoinswap.svg" class="h-6 inline-block" alt="Shitcoin Swap Logo"/>
      </a>
      <button class="z-100 btn primary small !md:hidden" aria-label="Menu" onclick={toggle}>
        {#if $currentUser}
          <span class="i-mdi:menu text-2xl"></span>
        {:else}
          Sign up
          <span class="i-mdi:arrow-right"></span>
        {/if}
      </button>
    </div>
  </section>
</header>
  <MenuDrawer>
    {#if $currentUser}
      <section>
        <p>
          Logged in as {$currentUser?.name}
        </p>
        <a href="/session" data-method="delete">Log out</a>
      </section>
      <ViewStack id="user" >
        <Frame src="/balances" historyState={false} />
      </ViewStack>
    {:else}
      <Frame src="/user/new" historyState={false} />
    {/if}
  </MenuDrawer>
  <footer>
    <section class="text-gray">
    <div class="flex items-center gap-2">
      <p class="grow">
        &copy; 2026 Shitcoin Swap
      </p>
      <div class="text-3xl md:text-2xl gap-4 flex justify-around">
        
        <!-- <a href="https://discord.gg/dgZFYEnS3J" target="_blank" class="text-gray">
          <div class="i-akar-icons:discord-fill"></div>
        </a> -->
        <a href="https://youtube.com/@shitcoinswap" target="_blank" class="text-gray">
          <div class="i-akar-icons:youtube"></div>
        </a>
        <a href="https://instagram.com/shitcoinswap" target="_blank" class="text-gray">
          <div class="i-akar-icons:instagram-fill"></div>
        </a>
        <a href="https://twitter.com/shitcoinswap" target="_blank" class="text-gray">
          <div class="i-akar-icons:x-fill"></div>
        </a>
        <a href="https://www.linkedin.com/company/shitcoinswap" target="_blank" class="text-gray">
          <div class="i-akar-icons:linkedin-fill"></div>
        </a>
      </div>
    </div>
    </section>
  </footer>
</div>

<Modal />

<style>
  .layout {
    display: grid;
    height: 100%;
    width: 100%;
    margin: 0 auto;
    grid-template-rows: auto 1fr auto;
    grid-template-areas: 
      "header"
      "main"
      "footer";
  }

  footer {
    border-top: 1px solid var(--color-border);
  }

  header {
    grid-area: header;
    border-bottom: 1px solid var(--color-border);
    position: sticky;
    top: 0;
    background: var(--color-background);
    backdrop-filter: blur(20px);
  }
  
  @media (min-width: 760px) {
    .layout {
      display: grid;
      flex: 1;
      border-left: 1px solid var(--color-border);
      border-right: 1px solid var(--color-border);
      grid-template-columns: 1fr 340px;
      grid-template-rows: auto 1fr auto;
      grid-template-areas: 
        "header aside"
        "main aside"
        "footer aside";
    }
  }
</style>

